import { useState } from 'react';
import classNames from 'classnames';
import PageBlock from '@/components/PageBlock';

import styles from './faq.module.css';

const FaqItem = ({ question, answer, open, onOpenChange }) => {
  return (
    <div className={styles.item}>
      <div className={classNames(styles.itemHeader, open && styles.open)} onClick={onOpenChange}>
        <div className={styles.itemTitle}>{question}</div>
        <img src="/icons/chevron-down.svg" className={styles.itemArrow} alt="" />
      </div>
      {open && <div className={styles.itemContent} dangerouslySetInnerHTML={{ __html: answer }} />}
    </div>
  );
};

const Faq = ({ title, items }) => {
  const [openIndex, setOpenIndex] = useState(null);
  return (
    <PageBlock variant="white" className={styles.root} id="faq" title={title}>
      <div className={styles.items}>
        {items.map(({ question, answer }, index) => (
          <FaqItem
            question={question}
            answer={answer}
            open={openIndex === index}
            onOpenChange={() => setOpenIndex(index)}
            key={index}
          />
        ))}
      </div>
      <div className={styles.footer}>
        Получите больше ответов по телефону <a href="tel:+78002007105">8 (800) 200-71-05</a>
      </div>
    </PageBlock>
  );
};

export default Faq;
